import { createSelector } from '@ngrx/store';
import { getSharedFeatureState } from '../shared.state';

export class LoggedInUserSelectors {
  private static readonly getLoggedInUserState = createSelector(
    getSharedFeatureState,
    (state) => state.loggedInUserState
  );
  static readonly getUser = createSelector(LoggedInUserSelectors.getLoggedInUserState, (state) => state?.user);
  static readonly getError = createSelector(LoggedInUserSelectors.getLoggedInUserState, (state) => state?.error);
}
